<template>
  <div>
    <div class="page-main has-bottom">
      <page-title :back="true" @goback="goback" />
      <page-card style="margin-bottom:32px" v-loading="loading">
        <template slot="header">Producer Information</template>
        <div slot="body">
          <base-info :pageData.sync="pageData" />
          <div class="add-header">Well Information</div>
          <wellComp
            v-for="(well, index) in wellList"
            :key="'well'+index"
            :pageData="well"
            :wellIndex="index"
          />
        </div>
      </page-card>
    </div>

    <page-bottom>
      <template>
        <div class="page-btns" v-if="$route.query.type === 'reject'">
          <loading-btn type="primary" label="Submit" @clickHandle="handleSubmit($event, 1)" />
        </div>
        <div class="page-btns" v-else>
          <loading-btn type="primary" label="Reject" @clickHandle="reject($event, 6)" />
          <loading-btn type="primary" label="Approval" @clickHandle="approval($event, 1)" />
        </div>
      </template>
    </page-bottom>
    <editInformationSuccess
      ref="editInformationSuccess"
      @close="goback"
      :noTip="true"
      msg="Approved completed!"
    />
  </div>
</template>

<script>
import { producerDetail, updateWellStatus } from '@/api/manager.js'
import wellComp from '@/views/wellManage/myWells/wellInfo.vue'
import baseInfo from '@/views/wellManage/myWells/baseInfo.vue'
import editInformationSuccess from '@/views/authentication/editInformationSuccess.vue'
export default {
  components: {
    wellComp,
    editInformationSuccess,
    baseInfo,
  },
  data() {
    return {
      loading: false,
      pageData: {
        accAddress: undefined,
        companyName: undefined,
        wellLicense: undefined,
      },
      wellList: [],
    }
  },
  computed: {},
  methods: {
    getInfo() {
      this.loading = true
      const param = {
        wellID: this.$route.query.wellID,
      }
      producerDetail(param)
        .then((res) => {
          let resData = res.result || {}
          this.pageData = resData
          this.wellList = resData.data.wellData
            ? [resData.data.wellData]
            : [resData.data]
          this.loading = false
        })
        .catch((err) => {
          this.loading = false
        })
    },
    reject(btn, status) {
      try {
        this.$confirm(
          'Are you sure to reject the application ?',
          'Operation confirmation',
          {
            confirmButtonText: 'Yes',
            cancelButtonText: 'No',
            type: 'warning',
          }
        )
          .then(() => {
            const param = {
              userID: this.$route.query.userID,
              wellID: this.$route.query.wellID,
              status,
            }
            this.submitContract({
              account: this.pageData.account,
              UWI: this.wellList[0].UWI,
              bool: false,
            })
              .then((resContract) => {
                updateWellStatus(param).then((res) => {
                  setTimeout(() => {
                    btn.closeLoad()
                    this.$refs.editInformationSuccess.open()
                  }, 100)
                })
              })
              .catch((e) => {
                btn.closeLoad()
              })
          })
          .catch((e) => {
            btn.closeLoad()
          })
      } catch (e) {
        console.log(err)
        btn.closeLoad()
      }
    },
    submitContract({ account, UWI, bool }) {
      return new Promise((resolve, reject) => {
        try {
          this.contractGovernance =
            this.$store.getters.contractMap['contractGovernance'].contract
          this.contractGovernanceAddress =
            this.$store.getters.contractMap['contractGovernance'].address
          const tx_builder = this.contractGovernance.methods[
            'setProducerStatus'
          ](account, UWI, bool)
          const encoded_tx = tx_builder.encodeABI()
          web3.eth
            .sendTransaction({
              gas: this.$store.getters.gas,
              from: this.$store.getters.metaMaskObj.account,
              to: this.contractGovernanceAddress,
              value: 0,
              data: encoded_tx,
            })
            .then((res) => {
              resolve()
            })
            .catch((error) => {
              console.error(error)
              reject(error)
            })
        } catch (e) {
          reject(e)
          console.error(e)
          this.$message.error('operation failed')
        }
      })
    },
    approval(btn, status) {
      try {
        this.$confirm(
          'Are you sure to approve the application ?',
          'Operation confirmation',
          {
            customClass: 'page-btns',
            confirmButtonText: 'Yes',
            cancelButtonText: 'No',
            type: 'warning',
          }
        )
          .then(() => {
            let contractParam = {
              account: this.pageData.account,
              UWI: this.wellList[0].UWI,
              bool: true,
            }
            this.submitContract(contractParam)
              .then((res) => {
                const param = {
                  userID: this.$route.query.userID,
                  wellID: this.$route.query.wellID,
                  status,
                }
                updateWellStatus(param).then((res) => {
                  setTimeout(() => {
                    btn.closeLoad()
                    this.$refs.editInformationSuccess.open()
                  }, 100)
                })
              })
              .catch((e) => {
                btn.closeLoad()
              })
          })
          .catch((e) => {
            btn.closeLoad()
          })
      } catch (e) {
        console.log(err)
        btn.closeLoad()
      }
    },
    handleSubmit(btn) {
      try {
        this.$confirm(
          'After confirmation, the well will be invalid and cannot create Rep ?',
          'Please note',
          {
            confirmButtonText: 'Confirm',
            cancelButtonText: 'Cancel',
            type: 'warning',
          }
        )
          .then(() => {
            const param = {
              userID: this.$route.query.userID,
              wellID: this.$route.query.wellID,
              status:3,
            }
            this.submitContract({
              account: this.pageData.account,
              UWI: this.wellList[0].UWI,
              bool: false,
            })
              .then((resContract) => {
                updateWellStatus(param).then((res) => {
                  btn.closeLoad()
                  this.$message.success('Submitted successfully!')
                  this.goback()
                })
              })
              .catch((e) => {
                btn.closeLoad()
              })
          })
          .catch((e) => {
            btn.closeLoad()
          })
      } catch (e) {
        console.log(err)
        btn.closeLoad()
      }
    },
    goback() {
      this.$router.push('/annualReview/approve')
    },
  },
  created() {
    this.getInfo()
  },
}
</script>
<style scoped lang="scss">
.page-main {
  ::v-deep .page-card .page-card_head {
    border-bottom: none;
  }
  ::v-deep .page-card .page-card_body {
    padding-top: 0;
  }
  .add-header {
    padding: 0.24 rem 0.32 rem;
    border-bottom: 1 px solid #f0f0f0;
    font-size: 0.22rem;
    font-weight: bold;
    margin: 0.24rem 0;
  }
}
</style>
